import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import moment from "moment";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import { get_transfer } from "../../../../Controllers/Inventory/Transfer";
import { get_request } from "../../../../Controllers/Inventory/Request";

const RequestView = () => {
  let componentRef = useRef();

  let { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [companyName, setCompanyName] = useState("For Company");

  // const injectGlobalStyles = () => {
  //   const style = document.createElement("style");
  //   style.innerHTML = `
  //     @page {
  //       size: A4;
  //       margin: 6% 6% 16% 6%;
  //        @bottom-left {
  //       font-size: 12px;
  //      content: "\\A \\A \\A \\A Customer's Signature (Name/Designation/Co. Seal) \\A \\A \\A";
  //       white-space: pre;
  //       position: fixed;
  //       bottom: 10mm;
  //       left: 6%;
  //     }
  //     @bottom-right {
  //       font-size: 12px;
  //         content: "\\A \\A \\A \\A For ${companyName} \\A \\A " counter(page) " of " counter(pages);
  //       white-space: pre;
  //       position: fixed;
  //       bottom: 10mm;
  //       right: 6%;
  //     }
  //     }
  //   `;
  //   document.head.appendChild(style);
  // };

  const [details, setDetails] = useState();

  const fetchData = async () => {
    setLoader(true);

    let data = {
      id: id,
    };

    let transfer = await get_request(data);
    if (transfer?.status) {
      // console.log(transfer?.data, "transfer?.data");
      setDetails(transfer?.data);
      setCompanyName(transfer?.data?.branch?.name);
      setLoader(false);
    } else {
      toast?.error(transfer?.message);
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   fetchData();
  //   if (companyName) {
  //     injectGlobalStyles(companyName);
  //   }
  // }, [companyName]);

  // console.log(details?.details, "etails?.details");

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
                .a4-invoice-container {
                  @page {
                    size: A4;
                    margin: 4% 4% 12% 4%;
                  }
            
                  .a4-invoice-footer {
                    font-size: 12px;
                    white-space: pre;
                    position: fixed;
                    bottom: 10mm;
                    left: 6%;
                  }
                  
                  .a4-invoice-footer-right {
                    font-size: 12px;
                    white-space: pre;
                    position: fixed;
                    bottom: 10mm;
                    right: 6%;
                  }
                }
              `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
    injectScopedStyles();
  }, []);

  return (
    <div className="p-4">
      {/* page */}
      <Loadercomponent loader={loader}>
        <div className="flex justify-center">
          <div className="w-[8.27in]  text-right py-4">
            <ReactToPrint
              trigger={() => (
                <div className="">
                  <PrinterOutlined className="text-2xl" />
                </div>
              )}
              content={() => componentRef}
            />
          </div>
        </div>
        <div
          className="flex justify-center a4-invoice-container"
          ref={(el) => (componentRef = el)}
        >
          <div>
            {/* <div className="flex justify-center">
          <div className="page-a4 w-full p-4" ref={(el) => (componentRef = el)}> */}
            {/*letter header */}
            <div className="text-black-900 text-[0.65rem] text-center">
              <div className="text-center">
                <div className="text-medium text-xl">
                  {details?.branch?.name}
                </div>
                <div className="text-medium">{details?.branch?.category}</div>
              </div>
            </div>
            <div className="text-black-900 text-[0.65rem] text-center pt-4">
              <span>
                Email&nbsp;:&nbsp;
                {details?.branch?.email ? details?.branch?.email + ", " : ""}
                &nbsp;
              </span>
              <span>
                Phone&nbsp;:&nbsp;
                {details?.branch?.phone ? details?.branch?.phone : "N/A"}
                &nbsp;
              </span>
              {/* <span>F.Code&nbsp;:&nbsp;8756432,&nbsp;</span> */}
              <div>
                {details?.branch?.area ? details?.branch?.area + ", " : ""}
                {details?.branch?.city ? details?.branch?.city + ", " : ""}
                {details?.branch?.country ? details?.branch?.country : ""}
              </div>
              <div>
                VATIN&nbsp;:&nbsp;
                {details?.branch?.tax ? details?.branch?.tax : "N/A"}
              </div>
            </div>
            {/* heading */}
            <hr className="my-4 border-t-black-900 border-black" />
            <div className="text-medium text-xl text-center">
              Transfer Request
            </div>
            <div className="text-xs pb-6">
              <div className="flex justify-between">
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td className="font-semibold text-sm">
                          {details?.supplier?.name}
                        </td>
                      </tr>
                      <tr>
                        <td>{details?.supplier?.area}</td>
                      </tr>
                      <tr>
                        <td>
                          {details?.supplier?.city
                            ? details?.supplier?.city + ", "
                            : " "}
                          {details?.supplier?.state}
                        </td>
                      </tr>
                      <tr>
                        <td>{details?.supplier?.country}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td>Transfer No</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          #REQUEST-{details?.number}
                        </td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment?.(details?.date)?.format?.("DD-MM-YYYY")}
                        </td>
                      </tr>
                      <tr>
                        <td>Due</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment?.(details?.due_date)?.format?.("DD-MM-YYYY")}
                        </td>
                      </tr>
                      <tr>
                        <td>Reference</td>
                        <td className="px-2">:</td>
                        <td className="text-right">N/A</td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td className="px-2">:</td>
                        <td className="text-right">N/A</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* table */}
            <div className="">
              <table className="w-full">
                <thead className="bg-black">
                  <tr className="text-sm">
                    <th className="font-normal  text-white  text-left py-2 pl-3">
                      S.No
                    </th>
                    <th className="font-normal text-white text-left p-2">
                      Description
                    </th>
                    <th className="font-normal text-white text-center p-2">
                      Units
                    </th>
                    <th className="font-normal text-white text-center p-2">
                      Quantity
                    </th>
                    {/* <th className="font-normal text-white text-center p-2">
                      Price
                    </th>
                    <th className="font-normal text-white text-center">Tax</th>
                    <th className="font-normal text-white text-right pr-2">
                      Total
                    </th> */}
                  </tr>
                </thead>
                {/* table body */}
                <tbody className="text-sm">
                  {details?.details?.map((value, index) => {
                    return (
                      <tr className="uppercase border-b border-gray-300 ">
                        <td className="py-1 text-center">{index + 1}</td>
                        <td className="py-1 text-left">
                          <div className="">{value?.name}</div>
                        </td>
                        <td className="py-1 text-center">{value?.unit_name}</td>
                        <td className="py-1 text-center">{value?.quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {/* <div className="">
            <div
              className="page-footer mb-[1.5cm]"
              style={{ padding: " 1.6cm" }}
            >
              <div className="flex justify-between px-[0.5cm]">
                <div className="text-[0.65rem]">
                  Customer's Signature (Name/Designation/Co. Seal)
                </div>
                <div className="text-[0.65rem]">For New Pharmacy LLC</div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </Loadercomponent>
    </div>
  );
};

export default RequestView;
